import { NAV, PHONE_1, PHONE_1_TEL, EMAIL, ADDRESS, SHOP_URL } from "@/data/site";
import { ArrowUpRight } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-brand-blueDeep text-slate-300" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-16 grid gap-12 md:grid-cols-12">
        <div className="md:col-span-5">
          <img src="/assets/logo.png" alt="Sevayog Facilities Pvt Ltd" className="h-14 w-auto rounded-lg bg-white p-1" />
          <p className="mt-5 max-w-sm text-sm leading-relaxed text-slate-400">
            Wholesale supplier of housekeeping items and office stationery. Cleenvo is our own
            brand of cleaning essentials — trusted by homes and businesses across India.
          </p>
          <a
            href={SHOP_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-shop-link"
            className="mt-6 inline-flex items-center gap-2 rounded-full bg-brand-green px-5 py-2.5 text-sm font-bold text-white transition-all duration-200 hover:bg-brand-greenDark hover:-translate-y-0.5"
          >
            Shop Cleenvo on officiaa.com
            <ArrowUpRight size={15} />
          </a>
        </div>
        <div className="md:col-span-3">
          <h4 className="font-display text-sm font-bold uppercase tracking-widest text-white">Explore</h4>
          <ul className="mt-5 space-y-3">
            {NAV.map((n) => (
              <li key={n.href}>
                <a href={n.href} className="text-sm text-slate-400 transition-colors hover:text-white" data-testid={`footer-nav-${n.label.toLowerCase().replace(/\s/g, "-")}`}>
                  {n.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-4">
          <h4 className="font-display text-sm font-bold uppercase tracking-widest text-white">Reach Us</h4>
          <ul className="mt-5 space-y-3 text-sm text-slate-400">
            <li><a href={PHONE_1_TEL} className="hover:text-white transition-colors" data-testid="footer-phone">{PHONE_1}</a></li>
            <li><a href={`mailto:${EMAIL}`} className="hover:text-white transition-colors" data-testid="footer-email">{EMAIL}</a></li>
            <li data-testid="footer-address">{ADDRESS}</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-6 flex flex-wrap items-center justify-between gap-3 text-xs text-slate-500">
          <span data-testid="footer-copyright">© 2026 Sevayog Facilities Pvt Ltd. All rights reserved.</span>
          <span>Cleenvo is a brand of Sevayog Facilities Pvt Ltd · Shop at officiaa.com</span>
        </div>
      </div>
    </footer>
  );
}
